import React, { useState, useEffect } from "react";
import Grid from "../Grid/Grid";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import DropDownGrid from "../Grid/Components/DropDownGrid";
import {
  Box,
  MenuItem,
  ListItemIcon
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Cookies from "universal-cookie";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from "react-router-dom";
import Search from "./Search";
import userAPI from "../../Network/User";
import FormContainer from "./Form/FormContainer";
import Title from "./Title";
import LockIcon from '@mui/icons-material/Lock';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import { selectRoles } from "../../reduxStore/RolesReducer";
import UserRolesTree from "./Roles/UserRolesTree";
import UserUnits from "./Roles/UserUnits";
import UserDestinationGeofences from "./Roles/UserDestinationGeofences";
import UserGeofenceGroups from "./Roles/UserGeofenceGroups";
import UserAccountsTree from "./Roles/UserAccountsTree";
import AccountBoxIcon from '@mui/icons-material/AccountBox';

const cookies = new Cookies();

export default function Users() {
  const [t] = useTranslation("common");
  const [rows, setRows] = useState([]);
  const maintheme = useSelector((state) => state.themeData.maintheme);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(false);

  const [pageCount, setPageCount] = useState(0);
  const [openFilterColumn, setOpenFilterColumn] = useState(false);
  const [openFilterColumnValue, setOpenFilterColumnValue] = useState([]);
  const [elementClicked, setElementClicked] = useState(null);

  const [filters, setFilters] = useState({
    name: "",
    user_name: "",
    enabled: null,
    wialon_id: null
  })
  const [reload, setReload] = useState(false)

  const [openForm, setOpenForm] = useState(false);
  const [selectedObject, setselectedObject] = useState(null);
  const [showAssignRoles, setShowAssignRoles] = useState(false)
  const [showMonitoredUnits, setShowMonitoredUnits] = useState(false)
  const [showMonitoredDestinationGeofences, setShowMonitoredDestinationGeofences] = useState(false)
  const [showUpdateGeofenceGroups, setShowUpdateGeofenceGroups] = useState(false)
  const [showAssignAccounts, setShowAssignAccounts] = useState(false)

  const handlePageChange = (newPage) => {
    setPageNumber(newPage + 1);
  };

  const navigate = useNavigate();
  const controller = new AbortController();
  const [rowsTotal, setRowsTotal] = useState(0);
  const screenwidth = useSelector((state) => state.settingsData.screenwidth);

  const rolesRedux = useSelector(selectRoles)

  const columns = [
    { field: "id", headerName: "#", minWidth: 50, maxWidth: 100 },
    { field: "account_name", headerName: t("USERS.account_name"), minWidth: 200, maxWidth: 250, flex: 2 },
    { field: "wialon_user", headerName: t("USERS.wialon_user"), minWidth: 200, maxWidth: 250, flex: 2 },
    { field: "name", headerName: t("USERS.name"), minWidth: 110, maxWidth: 150, flex: 2 },
    { field: "phone", headerName: t("USERS.phone"), minWidth: 110, maxWidth: 150, flex: 2 },
    { field: "formatted_last_login_date", headerName: t("USERS.formatted_last_login_date"), minWidth: 110, maxWidth: 150, flex: 2 },

    {
      field: "enabled", headerName: t("USERS.enabled"), minWidth: 110, maxWidth: 150, flex: 1,
      renderCell: (rows) => (
        <>
          {rows?.row?.enabled ? (
            <MenuItem
              onClick={() => {

              }}
              className="ActionIcons"
            >
              <ListItemIcon
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "0px 7px 0 0",
                }}
              >
                <CheckCircleIcon style={{ fill: "#388e3c" }} />
              </ListItemIcon>

            </MenuItem>
          ) : <MenuItem
            onClick={() => {

            }}
            className="ActionIcons"
          >
            <ListItemIcon
              sx={{
                display: "flex",
                justifyContent: "center",
                margin: "0px 7px 0 0",
              }}
            >
              <DoDisturbOnIcon style={{ fill: "#d32f2f" }} />
            </ListItemIcon>


          </MenuItem>}
        </>
      )
    },


    {
      headerName: t("USERS.actions"),
      field: "Actions",
      flex: 0.4,
      minWidth: 100,
      hide: !rolesRedux?.update_user?.value && !rolesRedux?.update_user_roles?.value,
      renderCell: (rows) => (
        <DropDownGrid>
          {
            rolesRedux?.update_user?.value ?

              <MenuItem onClick={() => { updateFunction(rows?.row) }} className="ActionIcons">
                <ListItemIcon sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  margin: '0px 7px 0 0'
                }}>
                  <EditIcon style={{ fill: maintheme?.primary }} />

                </ListItemIcon>
                {t('GLOBAL.action_edit')}
              </MenuItem> : null}
          {
            rolesRedux?.update_user_roles?.value ?
              <MenuItem onClick={() => { assignRole(rows?.row) }} className="ActionIcons">
                <ListItemIcon sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  margin: '0px 7px 0 0'
                }}>
                  <LockIcon style={{ fill: maintheme?.primary }} />
                </ListItemIcon>
                {t('USERS.assign_roles')}

              </MenuItem>
              : null
          }
          {
            rolesRedux?.update_user_units?.value ?
              <MenuItem onClick={() => { monitorUnits(rows?.row) }} className="ActionIcons">
                <ListItemIcon sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  margin: '0px 7px 0 0'
                }}>
                  <LocalShippingIcon style={{ fill: maintheme?.primary }} />
                </ListItemIcon>
                {t('USERS.monitor_units')}
              </MenuItem>
              : null
          }
          {
            rolesRedux?.update_user_units?.value ?
              <MenuItem onClick={() => { monitorDestinationGeofences(rows?.row) }} className="ActionIcons">
                <ListItemIcon sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  margin: '0px 7px 0 0'
                }}>
                  <GpsFixedIcon style={{ fill: maintheme?.primary }} />
                </ListItemIcon>
                {t('USERS.monitor_destination_geofences')}
              </MenuItem>
              : null
          }
          {
            rolesRedux?.update_user_geofence_groups?.value ?
              <MenuItem onClick={() => { updateGeofenceGroups(rows?.row) }} className="ActionIcons">
                <ListItemIcon sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  margin: '0px 7px 0 0'
                }}>
                  <GroupWorkIcon style={{ fill: maintheme?.primary }} />
                </ListItemIcon>
                {t('USERS.geofence_groups')}
              </MenuItem>
              : null
          }
          {
            rolesRedux?.update_user_roles?.value ?
              <MenuItem onClick={() => { assignAccounts(rows?.row) }} className="ActionIcons">
                <ListItemIcon sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  margin: '0px 7px 0 0'
                }}>
                  <AccountBoxIcon style={{ fill: maintheme?.primary }} />
                </ListItemIcon>
                {t('USERS.assign_accounts')}
              </MenuItem>
              : null
          }

        </DropDownGrid>
      ),
    },
  ]


  useEffect(() => {
    loadData()
  }, [pageNumber, pageSize, reload]);

  const loadData = async (searchParams) => {
    if (
      cookies.get("active_session") &&
      cookies.get("active_session") == "yes"
    ) {
      let object = {
        username: cookies.get("user_name") ? cookies.get("user_name") : null,
        user_id: cookies.get("user_id") ? cookies.get("user_id") : null,
        account_name: cookies.get("account_name") ? cookies.get("account_name") : null,
        account_id: cookies.get("account_id") ? cookies.get("account_id") : null,
        authHash: cookies.get("authHash") ? cookies.get("authHash") : null,
        sid: cookies.get("sid") ? cookies.get("sid") : null,
        baseurl: cookies.get("baseUrl") ? cookies.get("baseUrl") : null,
        id: cookies.get("id") ? cookies.get("id") : null,
        page: pageNumber,
        page_size: pageSize,
        search: "",
        from_wialon: 1,
        ...searchParams,
        ...filters
      };

      setLoading(true);

      const result = await userAPI.users({
        params: object,
        signal: controller?.signal,
      });
      setLoading(false);

      if (result.status && result?.data?.data?.data) {




        if (result?.data?.data?.data?.length > 0) {
          setRows(result?.data?.data?.data);
          setRowsTotal(result?.data?.data?.total_records);
          setPageCount(Math.ceil(result?.data?.data?.total_records / pageSize));
        }
        else {
          setRows([]);
          setRowsTotal(0);
          setPageCount(0);
        }
      } else {

        if (result?.data?.data?.message) {
          toast.error(result?.data?.data?.message?.text ? result?.data?.data?.message?.text : result?.data?.data?.message)
        }
        else if (result?.data?.data?.message) {
          toast.error(result?.data?.data?.message?.text ? result?.data?.data?.message?.text : result?.data?.data?.message)
        }
        else if (!result?.data?.error) {
          toast.error(t("NETWORK_MESSAGES.unknownError"));
          return;
        }
        if (result && result?.data && result?.data?.data?.message) {
          if (result?.data?.data?.message?.text == "unauthorized to complete") {
            navigate("/redirect");
          }
        }
      }
      setLoading(false);
    } else {
      navigate("/redirect");
    }
  };


  const monitorUnits = (obj) => {
    setselectedObject(obj)
    setShowMonitoredUnits(true)
  }
  const monitorDestinationGeofences = (obj) => {
    setselectedObject(obj)
    setShowMonitoredDestinationGeofences(true)
  }
  const updateGeofenceGroups = (obj) => {
    setselectedObject(obj)
    setShowUpdateGeofenceGroups(true)
  }
  const assignAccounts = (obj) => {
    setselectedObject(obj)
    setShowAssignAccounts(true)
  }
  const assignRole = (obj) => {
    setselectedObject(obj)
    setShowAssignRoles(true)
  }
  const createFunction = () => {
    setselectedObject(null);
    setOpenForm(true);
  };
  const updateFunction = (obj) => {
    setselectedObject(obj)
    setOpenForm(true)
  }

  const clearFilterFunction = () => {
    setFilters({
      name: "",
      code: "",
      user_account_name: "",
      wialon_user: "",
      phone: "",
      type_id: null,
      wialon_id: null
    })
  }
  const searchFunction = () => {
    setReload(!reload)
    setPageNumber(1)
  };

  return (
    <Box
      sx={{

        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "start",
        overflowX: "hidden",
        "& .MuiChip-label": {
          fontFamily: "Cairo-Medium",
        },
      }}
    >

      {openForm ? (
        <FormContainer
          object={selectedObject}
          openForm={openForm}
          setOpenForm={setOpenForm}
          loadData={loadData}
        />
      ) : null}
      {showAssignRoles ? (
        <UserRolesTree

          object={selectedObject}
          openForm={showAssignRoles}
          setOpenForm={setShowAssignRoles}
          loadData={loadData}
        />
      ) : null}
      {showMonitoredUnits ? (
        <UserUnits

          object={selectedObject}
          openForm={showMonitoredUnits}
          setOpenForm={setShowMonitoredUnits}
          loadData={loadData}
        />
      ) : null}
      {showMonitoredDestinationGeofences ? (
        <UserDestinationGeofences

          object={selectedObject}
          openForm={showMonitoredDestinationGeofences}
          setOpenForm={setShowMonitoredDestinationGeofences}
          loadData={loadData}
        />
      ) : null}
      {showUpdateGeofenceGroups ? (
        <UserGeofenceGroups
          object={selectedObject}
          openForm={showUpdateGeofenceGroups}
          setOpenForm={setShowUpdateGeofenceGroups}
          loadData={loadData}
        />
      ) : null}
      {showAssignAccounts ? (
        <UserAccountsTree
          object={selectedObject}
          openForm={showAssignAccounts}
          setOpenForm={setShowAssignAccounts}
          loadData={loadData}
        />
      ) : null}

      <Grid
        rows={rows}
        columns={columns}
        pageSize={pageSize}
        setPageSize={setPageSize}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        loading={loading}
        handlePageChange={handlePageChange}
        rowsTotal={rowsTotal}
        checkScreenSize={screenwidth}
        pageCount={pageCount}
        openFilterColumn={openFilterColumn}
        elementClicked={elementClicked}
        setOpenFilterColumn={setOpenFilterColumn}
        setColumnFilterValue={setOpenFilterColumnValue}
        columFilterValue={openFilterColumnValue}
        clearFunction={clearFilterFunction}
        searchFunction={searchFunction}
        hasCreate={false}
        creatFunction={createFunction}
        LeftHeaderComponent={
          <Title
            createFunction={createFunction}
            openFilterColumn={openFilterColumn}
          />
        }
        filterChilds={
          <Search
            filters={filters}
            setFilters={setFilters}
          />
        }
      />

    </Box>
  );
}
